"use strict";
document.addEventListener("DOMContentLoaded", () => {
    const banerSections = document.querySelectorAll('.baner__ab');
    if (banerSections.length === 0) return;

    banerSections.forEach(section => {
        const titleContainer = section.querySelector('.title');
        const targetSpan = section.querySelector('.title span');

        if (titleContainer && targetSpan) {
            const containerRect = titleContainer.getBoundingClientRect();
            const spanRect = targetSpan.getBoundingClientRect();

            const offsetToRightEdge = containerRect.right - spanRect.right;

            targetSpan.style.setProperty('--offset', `${offsetToRightEdge}px`);
        }
    });

    const observerOptions = {
        root: null,
        rootMargin: '0px 0px -33.33% 0px',
        threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const title = entry.target.querySelector('.title');
                if (title) {
                    title.classList.add('show');
                }
            }
        });
    }, observerOptions);

    banerSections.forEach(section => {
        observer.observe(section);
    });
});